<figure>
  <label>
    <img [src]="url" appProfileImage alt="" />
    <input
      #input
      type="file"
      [formControl]="fileInputControl"
      [style.display]="'none'"
      [attr.accept]="acceptTypes || '*'"
      (change)="onFilePicked($event)"
    />
  </label>

  <button *ngIf="url">
    <mat-icon (click)="remove()">close</mat-icon>
  </button>
</figure>
